
import { RefObject } from 'react';
import { Button } from "@/components/ui/button"
import { Download, Upload, FileOutput, Trash2, FileSpreadsheet, FileText } from "lucide-react"
import { Category } from '@/types';

interface SidebarButtonsProps {
  fileInputRef: RefObject<HTMLInputElement>;
  onOpenSaveDialog: () => void;
  onOpenExportDialog: () => void;
  onOpenExportCSVDialog: () => void;
  onOpenImportExcelDialog: () => void;
  handleResetAll: () => void;
  categories: Category[];
}

export function SidebarButtons({
  fileInputRef,
  onOpenSaveDialog,
  onOpenExportDialog,
  onOpenExportCSVDialog,
  onOpenImportExcelDialog,
  handleResetAll,
  categories
}: SidebarButtonsProps) {
  const hasCategories = categories.length > 0;

  return (
    <>
      <Button
        variant="ghost"
        className="w-full justify-start text-white hover:text-white hover:bg-white/10"
        onClick={() => fileInputRef.current?.click()}
      >
        <Upload className="mr-2 h-4 w-4" />
        Load Project
      </Button>

      <Button
        variant="ghost"
        className="w-full justify-start text-white hover:text-white hover:bg-white/10"
        onClick={onOpenSaveDialog}
      >
        <Download className="mr-2 h-4 w-4" />
        Save Project
      </Button>

      <Button
        variant="ghost"
        className="w-full justify-start text-white hover:text-white hover:bg-white/10"
        onClick={onOpenExportDialog}
      >
        <FileOutput className="mr-2 h-4 w-4" />
        Export to Excel
      </Button>

      <Button
        variant="ghost"
        className="w-full justify-start text-white hover:text-white hover:bg-white/10"
        onClick={onOpenExportCSVDialog}
      >
        <FileText className="mr-2 h-4 w-4" />
        Export to CSV
      </Button>

      <Button
        variant="ghost"
        className="w-full justify-start text-white hover:text-white hover:bg-white/10"
        onClick={onOpenImportExcelDialog}
        disabled={hasCategories}
        title={hasCategories ? "Import is only possible when there are no existing categories" : "Import Excel file"}
      >
        <FileSpreadsheet className="mr-2 h-4 w-4" />
        Import Excel
      </Button>

      <Button
        variant="ghost"
        className="w-full justify-start text-white hover:text-white hover:bg-white/10"
        onClick={handleResetAll}
      >
        <Trash2 className="mr-2 h-4 w-4" />
        Reset All
      </Button>
    </>
  );
}
